import { toast } from "react-toast";

export const displaySuccess = (message: any) => {
  toast(message, {
    backgroundColor: "#459A33",
  });
};

export const displayError = (message: string) => {
  toast(message, {
    backgroundColor: "#B63434",
  });
};

export const convertToNumber = (val: string = "0") => {
  let _val = val;
  _val = _val.replaceAll(",", "");
  let num = parseFloat(_val);
  return num;
};

export const formatWithComma = (val: number) => {
  return new Intl.NumberFormat("en-US").format(val);
};
